export default __webpack_public_path__ + "static/media/bg.8ad08e56.jpg";